// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2cR5F","inputWrap":"styles_inputWrap__KGIGu","input":"styles_input__16Tdu"};